/**
 * Pack product-card color chips into one row at fixed size.
 * Shows as many as fit; leftover colors become "+N".
 */
(function () {
  var SELECTOR = "[data-swatch-row]";
  var CHIP = ".thumbnail-swatch, .color-swatch";
  var MORE = "[data-swatch-more]";
  var FALLBACK_CHIP_W = 58;
  var FALLBACK_MORE_W = 30;
  var scheduled = false;

  function chipWidth(chip) {
    var w = Math.ceil(chip.getBoundingClientRect().width);
    // Before images/layout settle, width can be 0 — use the CSS fixed size.
    if (w < 20) {
      if (chip.classList.contains("color-swatch")) return 24;
      return FALLBACK_CHIP_W;
    }
    return w;
  }

  function rowAvail(row) {
    var parent = row.parentElement;
    var avail = Math.min(
      row.clientWidth || Infinity,
      parent && parent.clientWidth ? parent.clientWidth : Infinity,
      Math.ceil(row.getBoundingClientRect().width) || Infinity
    );
    return Number.isFinite(avail) && avail > 0 ? avail : 0;
  }

  function fitRow(row) {
    var chips = Array.prototype.slice.call(row.querySelectorAll(CHIP));
    if (!chips.length) return;

    var more = row.querySelector(MORE);
    var total = parseInt(row.getAttribute("data-swatch-total") || chips.length, 10);
    if (!Number.isFinite(total) || total < 1) total = chips.length;

    chips.forEach(function (chip) {
      chip.hidden = false;
    });

    var styles = window.getComputedStyle(row);
    var gap = parseFloat(styles.columnGap || styles.gap) || 0;
    var avail = rowAvail(row);
    if (avail <= 0) {
      if (more) more.hidden = true;
      return;
    }

    var moreWidth = FALLBACK_MORE_W;
    if (more) {
      more.hidden = false;
      more.textContent = "+0";
      var mw = Math.ceil(more.getBoundingClientRect().width);
      if (mw >= 16) moreWidth = mw;
      more.hidden = true;
    }

    var widths = chips.map(chipWidth);
    var used = 0;
    var visible = 0;

    for (var i = 0; i < chips.length; i++) {
      var remainingAfter = total - (i + 1);
      var reserve = remainingAfter > 0 ? gap + moreWidth : 0;
      var next = used + (visible > 0 ? gap : 0) + widths[i] + reserve;

      if (next > avail + 0.5) {
        for (var j = i; j < chips.length; j++) {
          chips[j].hidden = true;
        }
        if (more && total - visible > 0) {
          more.hidden = false;
          more.textContent = "+" + (total - visible);
        }
        return;
      }

      used += (visible > 0 ? gap : 0) + widths[i];
      visible += 1;
    }

    var leftover = total - visible;
    if (more) {
      if (leftover > 0) {
        more.hidden = false;
        more.textContent = "+" + leftover;
      } else {
        more.hidden = true;
      }
    }
  }

  function fitAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    if (root && root.matches && root.matches(SELECTOR)) fitRow(root);
    Array.prototype.forEach.call(scope.querySelectorAll(SELECTOR), fitRow);
  }

  function scheduleFit(root) {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      fitAll(root);
    });
  }

  function observeImages(row) {
    row.querySelectorAll("img").forEach(function (img) {
      if (img.complete) return;
      img.addEventListener("load", function () {
        fitRow(row);
      }, { once: true });
    });
  }

  function onReady() {
    document.querySelectorAll(SELECTOR).forEach(observeImages);
    fitAll(document);
    // Second pass after layout/images catch up
    setTimeout(function () {
      fitAll(document);
    }, 100);
    setTimeout(function () {
      fitAll(document);
    }, 500);

    if (typeof ResizeObserver !== "undefined") {
      var ro = new ResizeObserver(function (entries) {
        entries.forEach(function (entry) {
          fitRow(entry.target);
        });
      });
      document.querySelectorAll(SELECTOR).forEach(function (row) {
        ro.observe(row);
      });

      var mo = new MutationObserver(function (mutations) {
        var needs = false;
        mutations.forEach(function (m) {
          m.addedNodes.forEach(function (node) {
            if (node.nodeType !== 1) return;
            if (node.matches && (node.matches(SELECTOR) || node.querySelector(SELECTOR))) {
              needs = true;
              if (node.matches(SELECTOR)) {
                ro.observe(node);
                observeImages(node);
              }
              node.querySelectorAll &&
                node.querySelectorAll(SELECTOR).forEach(function (row) {
                  ro.observe(row);
                  observeImages(row);
                });
            }
          });
        });
        if (needs) scheduleFit(document);
      });
      mo.observe(document.body, { childList: true, subtree: true });
    } else {
      window.addEventListener("resize", function () {
        scheduleFit(document);
      });
    }

    document.addEventListener("shopify:section:load", function () {
      scheduleFit(document);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", onReady);
  } else {
    onReady();
  }
})();
